/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown>, total: NonNullable<unknown> }} Signin_Code_BoxInputs */

const en_signin_code_box = /** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Digit ${i?.position} of ${i?.total}`)
};

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const ar_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const he_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const ur_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const es_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const fr_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const de_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const pt_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const hi_signin_code_box = en_signin_code_box;

/** @type {(inputs: Signin_Code_BoxInputs) => LocalizedString} */
const bn_signin_code_box = en_signin_code_box;

/**
* | output |
* | --- |
* | "Digit {position} of {total}" |
*
* @param {Signin_Code_BoxInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_code_box = /** @type {((inputs: Signin_Code_BoxInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_BoxInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_code_box(inputs)
	if (locale === "he") return he_signin_code_box(inputs)
	if (locale === "ur") return ur_signin_code_box(inputs)
	if (locale === "es") return es_signin_code_box(inputs)
	if (locale === "fr") return fr_signin_code_box(inputs)
	if (locale === "de") return de_signin_code_box(inputs)
	if (locale === "pt") return pt_signin_code_box(inputs)
	if (locale === "hi") return hi_signin_code_box(inputs)
	if (locale === "bn") return bn_signin_code_box(inputs)
	return en_signin_code_box(inputs)
});